export default data => (
    data.map(stop => ({
        id: stop.id,
        nameSeo: stop.nombreSeo,
        text: stop.txt,
        countryId: stop.paisId
    }))
)